export function applyFilter(
  value: string,
  filterValue: string,
  comparator: string,
): boolean {
  switch (comparator) {
    case 'Igual':
      return value.toLowerCase() === filterValue.toLowerCase();
    case 'Menor igual':
      return (
        parseFloat(value.replace(',', '.')) <=
        parseFloat(filterValue.replace(',', '.'))
      );
    case 'Maior igual':
      return (
        parseFloat(value.replace(',', '.')) >=
        parseFloat(filterValue.replace(',', '.'))
      );
    case 'Contém':
      return value.toLowerCase().includes(filterValue.toLowerCase());
    default:
      return false;
  }
}
